import React, { Component, Fragment } from "react";

import { Spinner } from "./Spinner";
import { Switch, withStyles, Grid } from "@material-ui/core/";
import Axios from "axios";
import { LoggedUserContext } from "../LoggedUserContext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { acquireToken } from "../adalConfig";

const MySwal = withReactContent(Swal);

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(0),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#FFE600",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#FFE600",
      border: "6px solid #000",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default class UserDeactivate extends Component {
  state = {
    id: "",
    userId: "",
    loading: false,
    status: true,
    userToAffect: {
      userId: "string",
      userStatus: true,
      userCreateDate: new Date(),
      userLastUpdateDate: new Date(),
      userModifiedId: "string",
    },
    userSession: this.context,
    userRolls: [
      {
        rollId: 0,
        rollName: "string",
        rollDescription: "string",
        rollCreateDate: new Date(),
        rollLastUpdateDate: new Date(),
        rollUserModifiedId: "string",
      },
    ],
    userEmailAccounts: [
      {
        emailAccountId: 0,
        emailAccountName: "string",
        emailAccountEmail: "string",
        emailAccountPassword: "string",
        emailAccountStatus: true,
        emailAccountCreateDate: new Date(),
        emailAccountLastUpdateDate: new Date(),
        emailAccountUserModifiedId: "string",
      },
    ],
  };

  async componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.id !== prevProps.id) {
      this.loadData();
    }
  }
  
  async loadData() {
    this.setState({
      loading: true,
      id: this.props.id,
      userId: this.context.userId,
    });

    await acquireToken().then(async (token) => {
      const { id, userId } = this.state;
      let url = `${process.env.REACT_APP_API_URL}/UserAPI/GetUsersPerId${id !== userId ? '?ui=' + this.encryptStringXORtoHex(id, "CampaignToolEncKey") : ''}`;
      
      await Axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (res.data.code === 0) {
            this.setState({ userToAffect: res.data.items[0] });
            this.setState({ status: res.data.items[0].userStatus });
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the user",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the user",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });

      url = `${process.env.REACT_APP_API_URL}/RollAPI/GetRollsPerUserId${id !== userId ? '?ui=' + this.encryptStringXORtoHex(id, "CampaignToolEncKey") : ''}`;
      await Axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (res.data.code === 0) {
              this.setState({ userRolls: res.data.items });
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the roll",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the roll",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });

      url = `${process.env.REACT_APP_API_URL}/EmailAccountAPI/GetEmailAccountsPerUserId/true${id !== userId ? '?ui=' + this.encryptStringXORtoHex(id, "CampaignToolEncKey") : ''}`;
      await Axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (res.data.code === 0) {
            this.setState({ userEmailAccounts: res.data.items });
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the email account",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the email account",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });
    });
    this.setState({ loading: false });
  }

  handlechangeSwitch = (name) => (event) => {
    const { userToAffect, userSession, userRolls, userEmailAccounts } = this.state;
    const preState = {
      userToAffect: {
        userId: this.props.id,
        userStatus: event.target.checked,
        userCreateDate: userToAffect.userCreateDate,
        userLastUpdateDate: new Date(),
        userModifiedId: "string",
      },
      userSession: userSession,
      userRolls: userRolls,
      userEmailAccounts: userEmailAccounts,
    };

    this.setState({
      userToAffect: {
        ...userToAffect,
        userStatus: event.target.checked,
      }
    });
    this.setState({status: event.target.checked});
    
    acquireToken().then((token) => {
      const url = `${process.env.REACT_APP_API_URL}/UserAPI/UpdateUser`;
      Axios.post(url, preState, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => {
          if (res.data.code === 0) {
            window.location.reload();
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while updating the user",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while updating the user",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
          }
        });
    });
  };

  render() {
    const { status, loading, id } = this.state;

    return loading ? (
      <Spinner />
    ) : (
      <Fragment>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={1}
        >
          <Grid item>
            <IOSSwitch
              size="small"
              id={id}
              checked={status}
              onChange={this.handlechangeSwitch("status")}
              margin="normal"
            />
          </Grid>
          <Grid item>
            <label>{status ? "Yes" : "No"}</label>
          </Grid>
        </Grid>
      </Fragment>
    );
  }

  encryptStringXORtoHex(input, key) {
    let result = "";
    if (!input) {
        input = "";
    }
    while (key.length < input.length) {
      key += key;
    }
    for (var i = 0; i < input.length; i++) {
      var value1 = input[i].charCodeAt(0);
      var value2 = key[i].charCodeAt(0);

      var xorValue = value1 ^ value2;

      var xorValueAsHexString = xorValue.toString("16");

      if (xorValueAsHexString.length < 2) {
        xorValueAsHexString = "0" + xorValueAsHexString;
      }

      result += xorValueAsHexString;
    }
    return result;
  }
}

UserDeactivate.contextType = LoggedUserContext;
